export default __webpack_public_path__ + "static/web-development-f9190330f5074f6438b47277f7166ea7.webp";